import debounce from 'lodash.debounce';
import onDOMContentLoaded from '../utils/on-dom-content-loaded';

const determineLocalNavTopMargin = () => {
  const hero = document.querySelector('.hero');

  if (hero) {
    const heroStyles = hero.currentStyle || window.getComputedStyle(hero);
    const heroMarginBottom = heroStyles.marginBottom;

    return `-${heroMarginBottom}`;
  }

  return 0;
};

const slideNavDown = () => {
  const htmlElement = document.querySelector('html');
  const header = document.querySelector('header');
  const localNav = document.querySelector('.local-nav');
  const headerHeight = header?.offsetHeight;
  const headerHeightInRem = headerHeight / 10;
  const localNavTopMargin = determineLocalNavTopMargin(localNav);
  const placeholderElement = document.getElementById('placeHolderLocalNav');

  htmlElement.style.setProperty('--scroll-padding-top-value', '13rem');

  header.style.marginTop = 0;

  placeholderElement?.remove();

  localNav.style.setProperty('--local-nav-top', `${headerHeightInRem}rem`);
  localNav.style.setProperty('--local-nav-position', 'sticky');
  localNav.style.setProperty('--local-nav-margin-top', localNavTopMargin);
};

const slideNavUp = (placeHolderLocalNav) => {
  const htmlElement = document.querySelector('html');
  const header = document.querySelector('header');
  const localNav = document.querySelector('.local-nav');
  const headerHeight = header?.offsetHeight;
  const localNavHeight = localNav?.offsetHeight;
  const placeHolderElement = document.getElementById('placeHolderLocalNav');

  htmlElement.style.setProperty('--scroll-padding-top-value', '7.2rem');
  localNav.style.setProperty('--local-nav-position', 'fixed');
  localNav.style.setProperty('--local-nav-top', `0`);
  localNav.style.setProperty('--local-nav-margin-top', 0);

  header.style.marginTop = `-${headerHeight}px`;
  if (!placeHolderElement) {
    header.append(placeHolderLocalNav);
  }
  // eslint-disable-next-line no-param-reassign
  placeHolderLocalNav.style.height = localNavHeight;
};

const handleMainNavFocusWhenHidden = () => {
  const localNav = document.querySelector('.local-nav');
  const header = document.querySelector('header');
  const headerLinks = document.querySelectorAll('header a, header button, header input');

  headerLinks.forEach((item) => {
    item.addEventListener('focus', () => {
      const headerIsHidden =
        header.style.marginTop !== '' ? parseInt(header.style.marginTop, 10) < 0 : false;
      if (localNav && headerIsHidden) {
        slideNavDown();
      }
    });
  });
};

const initLocalNav = () => {
  const isInitialLoad = true;
  const widowWidth = window.innerWidth;
  const htmlElement = document.querySelector('html');
  const header = document.querySelector('header');
  const headerHeight = header?.offsetHeight;
  const headerHeightInRem = headerHeight / 10;
  const localNav = document.querySelector('.local-nav');
  const localNavHeight = localNav?.offsetHeight;
  const headerAndLocalNavHeight = localNavHeight;

  htmlElement.style.setProperty('--header-height', `${headerHeightInRem}rem`);

  window.addEventListener('resize', () => {
    debounce(() => {
      if (window.innerWidth !== widowWidth || isInitialLoad) {
        // Reset the header height to then recalculate it
        htmlElement.style.setProperty('--header-height', '');
        htmlElement.style.setProperty('--header-height', `${header?.offsetHeight / 10}rem`);
      }
    }, 50);
  });

  if (localNav) {
    let lastScrollTop = 0;
    let nearBottomOfPage = false;
    let userScroll = false;
    const localNavTopMargin = determineLocalNavTopMargin(localNav);
    localNav.style.setProperty('--local-nav-margin-top', localNavTopMargin);
    localNav.style.setProperty('--local-nav-top', `${headerHeightInRem}rem`);

    window.addEventListener(
      'scroll',
      debounce(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrolledUp = scrollTop < lastScrollTop;
        const scrolledDown = scrollTop > lastScrollTop;
        const localNavInitialPosition = localNav.getBoundingClientRect().top;
        const placeHolderLocalNav = document.createElement('div');
        placeHolderLocalNav.setAttribute('id', 'placeHolderLocalNav');
        placeHolderLocalNav.setAttribute('style', `height: ${localNavHeight}px`);
        const userScrollEvent = new Event('userScroll');

        nearBottomOfPage =
          window.innerHeight + window.scrollY + headerAndLocalNavHeight >=
          document.body.offsetHeight;

        // prevents animation on page load if userScroll is false
        if (userScroll) {
          if (scrolledDown && localNavInitialPosition <= headerHeight) {
            slideNavUp(placeHolderLocalNav);
          } else if (scrolledUp && !nearBottomOfPage) {
            slideNavDown();
          } else if (scrolledUp && nearBottomOfPage && header.style.display === 'none') {
            slideNavDown();
          }
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
        userScroll = true;
        window.dispatchEvent(userScrollEvent);
      }, 50)
    );
  }
};

onDOMContentLoaded().then(() => {
  initLocalNav();
  handleMainNavFocusWhenHidden();
});
